(() => {
  const KEY = 'cavesdevinho.compare.v1';
  const SOURCE_KEY = 'cavesdevinho.compare.source.v1';
  const MAX = 5;
  const DAY = 86400000;
  const page = document.querySelector('[data-compare-page]');
  const tray = document.querySelector('[data-compare-tray]');
  let selection = read();
  const cache = new Map();
  const imageLookupAttempted = new Set();
  const rendered = new Map();
  let renderVersion = 0;
  let activeAlert;
  let alertTimer;

  function read() {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!saved || !Number.isFinite(saved.expires) || saved.expires < Date.now() || !Array.isArray(saved.items)) return [];
      const seen = new Set();
      const productId = item => typeof item.id === 'string' && /^\d+$/.test(item.id) ? item.id : '';
      return saved.items.filter(item => {
        if (!item || !/^[a-z0-9-]+$/.test(item.handle) || typeof item.url !== 'string' || !/^\/(?!\/)/.test(item.url) || seen.has(productId(item) || item.handle)) return false;
        seen.add(productId(item) || item.handle);
        return true;
      }).slice(0, MAX).map(item => ({handle: item.handle, id: productId(item), url: item.url, image: typeof item.image === 'string' ? item.image : '', title: typeof item.title === 'string' ? item.title : ''}));
    } catch (_) { return []; }
  }

  function persist() {
    try { localStorage.setItem(KEY, JSON.stringify({items: selection, expires: Date.now() + DAY})); } catch (_) {}
  }

  function previewUrl(url) {
    const result = new URL(url, location.origin);
    const previewId = new URLSearchParams(location.search).get('preview_theme_id');
    if (previewId) result.searchParams.set('preview_theme_id', previewId);
    else if (window.Shopify?.theme?.role === 'unpublished' && window.Shopify.theme.id) result.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    return result;
  }

  function localizedPath(path) {
    return (window.Shopify?.routes?.root || '/') + path.replace(/^\//, '');
  }

  function comparisonSource() {
    const referrer = document.referrer ? new URL(document.referrer) : null;
    const valid = url => url?.origin === location.origin && url.searchParams.get('view') !== 'compare';
    if (valid(referrer)) return referrer.pathname + referrer.search + referrer.hash;
    try {
      const saved = JSON.parse(sessionStorage.getItem(SOURCE_KEY) || 'null');
      const url = new URL(saved?.url || '', location.origin);
      if (saved && Date.now() - saved.at < DAY && valid(url) && saved.url.startsWith('/') && !saved.url.startsWith('//') && (referrer?.origin === location.origin || !document.referrer && Date.now() - saved.at < 60000)) return saved.url;
    } catch (_) {}
    return null;
  }

  if (page) {
    const source = comparisonSource();
    page.querySelectorAll('[data-compare-back]').forEach(link => {
      if (source) link.href = previewUrl(source).href;
      else {
        link.href = previewUrl(localizedPath('/collections/all')).href;
        const label = link.querySelector('span') || link;
        label.textContent = link.dataset.fallbackLabel;
      }
    });
  }

  function returnFromComparison() {
    const back = page.querySelector('[data-compare-back]');
    location.replace(back?.href || previewUrl(localizedPath('/collections/all')).href);
  }

  function renderImages(container, surface, kind) {
    if (!container) return;
    container.hidden = selection.length === 0;
    const signature = JSON.stringify(selection.map(({handle, image, title}) => [handle, image, title]));
    if (container.dataset.selection === signature) return;
    container.dataset.selection = signature;
    const scrollLeft = container.scrollLeft;
    const focused = container.contains(document.activeElement) ? document.activeElement.dataset.compareRemove : null;
    container.replaceChildren(...selection.map(item => {
      const wrapper = document.createElement('span');
      wrapper.className = `${kind}__image`;
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 56;
        img.height = 56;
        img.decoding = 'async';
        wrapper.append(img);
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = `${kind}__remove`;
      remove.dataset.compareRemove = item.handle;
      remove.setAttribute('aria-label', `${surface.dataset.removeLabel}: ${item.title || item.handle}`);
      remove.textContent = '×';
      wrapper.append(remove);
      return wrapper;
    }));
    container.scrollLeft = scrollLeft;
    if (focused) Array.from(container.querySelectorAll('[data-compare-remove]')).find(button => button.dataset.compareRemove === focused)?.focus({preventScroll: true});
  }

  function sameProduct(item, control) {
    return item.id && control?.dataset.productId ? item.id === control.dataset.productId : item.handle === control?.dataset.handle;
  }

  function sync() {
    let enriched = false;
    document.querySelectorAll('[data-compare-toggle]').forEach(control => {
      const selected = selection.find(item => sameProduct(item, control));
      const active = Boolean(selected);
      if (selected && ((!selected.image && control.dataset.image) || selected.title !== control.dataset.title)) {
        selected.image ||= control.dataset.image || '';
        selected.title = control.dataset.title || '';
        enriched = true;
      }
      control.disabled = false;
      if (control.type === 'checkbox') control.checked = active;
      else {
        control.setAttribute('aria-pressed', String(active));
        control.textContent = control.dataset[active ? 'removeLabel' : 'addLabel'];
      }
      if (control.closest('[data-compare-block]')) control.setAttribute('aria-label', `${control.dataset[active ? 'removeLabel' : 'addLabel']}: ${control.dataset.title}`);
    });
    document.querySelectorAll('[data-compare-block]').forEach(block => {
      block.dataset.selected = String(selection.some(item => sameProduct(item, block.querySelector('[data-compare-toggle]'))));
      block.querySelector('[data-compare-block-count]').textContent = selection.length;
      block.querySelector('[data-compare-open]').hidden = selection.length < 2;
      renderImages(block.querySelector('[data-compare-images]'), block, 'product-compare-block');
      if (selection.length < MAX) block.querySelector('[data-compare-alert]').hidden = true;
    });
    if (tray) {
      tray.hidden = selection.length === 0;
      if (selection.length < MAX) {
        clearTimeout(alertTimer);
        tray.querySelector('[data-compare-alert]').hidden = true;
      }
      tray.querySelector('[data-compare-count]').textContent = selection.length;
      tray.querySelector('[data-compare-open]').disabled = selection.length < 2;
      renderImages(tray.querySelector('[data-compare-images]'), tray, 'comparison-tray');
    }
    if (selection.length < MAX) {
      const toast = document.querySelector('[data-compare-toast]');
      if (toast) toast.hidden = true;
    }
    if (enriched) persist();
    document.querySelectorAll('[data-compare-clear]').forEach(button => { button.hidden = selection.length === 0; });
    if (selection.length && !page && (tray || document.querySelector('[data-compare-block]'))) hydrateLegacyImages();
  }

  function showLimit(control) {
    const surface = control.closest('[data-compare-block]') || tray;
    let alert;
    let animation;
    if (surface) {
      alert = surface.querySelector('[data-compare-alert]');
      alert.textContent = surface.dataset.limit;
      animation = surface === tray ? 'comparison-tray__alert--active' : 'product-compare-block__alert--active';
    } else {
      const message = control.dataset.limit || document.querySelector('[data-compare-block]')?.dataset.limit;
      if (!message) return;
      alert = document.querySelector('[data-compare-toast]');
      if (!alert) {
        alert = document.createElement('p');
        alert.className = 'comparison-limit-toast';
        alert.dataset.compareToast = '';
        alert.setAttribute('role', 'status');
        alert.setAttribute('aria-live', 'polite');
        document.body.append(alert);
      }
      alert.textContent = message;
      animation = 'comparison-limit-toast--active';
    }
    if (activeAlert && activeAlert !== alert) activeAlert.hidden = true;
    activeAlert = alert;
    alert.hidden = false;
    alert.classList.remove(animation);
    void alert.offsetWidth;
    alert.classList.add(animation);
    clearTimeout(alertTimer);
    alertTimer = setTimeout(() => { alert.hidden = true; }, surface ? 3200 : 5500);
  }

  function hydrateLegacyImages() {
    selection.filter(item => !item.image && !imageLookupAttempted.has(item.handle)).forEach(async item => {
      imageLookupAttempted.add(item.handle);
      try {
        const source = await productData(item);
        const selected = selection.find(current => current.handle === item.handle);
        if (!selected) return;
        selected.image = source.querySelector('.comparison-data__image img')?.src || '';
        selected.title = source.querySelector('.comparison-data__title')?.textContent || '';
        if (selected.image) { persist(); sync(); }
      } catch (_) {}
    });
  }

  function toggle(control) {
    const handle = control.dataset.handle;
    const index = selection.findIndex(item => sameProduct(item, control));
    if (index >= 0) selection.splice(index, 1);
    else if (selection.length < MAX) selection.push({handle, id: control.dataset.productId || '', url: control.dataset.url, image: control.dataset.image || '', title: control.dataset.title || ''});
    else {
      sync();
      showLimit(control);
      return;
    }
    persist();
    sync();
    if (page) render();
  }

  document.addEventListener('change', event => {
    if (event.target.matches('input[data-compare-toggle]')) toggle(event.target);
  });
  document.addEventListener('click', event => {
    const control = event.target.closest('button[data-compare-toggle]');
    if (control) toggle(control);
    const clear = event.target.closest('[data-compare-clear]');
    if (clear) {
      const surface = clear.closest('[data-compare-block], [data-compare-tray], [data-compare-page]');
      const fallback = surface?.querySelector('[data-compare-toggle]') || page?.querySelector('[data-compare-back]') || document.querySelector('[data-compare-toggle]');
      selection = [];
      persist();
      if (page) {
        returnFromComparison();
        return;
      }
      sync();
      fallback?.focus({preventScroll: true});
      return;
    }
    const retry = event.target.closest('[data-compare-retry]');
    if (retry) {
      const entry = rendered.get(retry.dataset.compareRetry);
      if (entry && entry.status === 'error') {
        entry.status = 'idle';
        render();
      }
      return;
    }
    if (event.target.closest('[data-compare-open]') && selection.length >= 2) {
      try { sessionStorage.setItem(SOURCE_KEY, JSON.stringify({url: location.pathname + location.search + location.hash, at: Date.now()})); } catch (_) {}
      const target = previewUrl(localizedPath('/collections/all'));
      target.searchParams.set('view', 'compare');
      location.assign(target.href);
    }
    const remove = event.target.closest('[data-compare-remove]');
    if (remove) {
      const surface = remove.closest('[data-compare-block], [data-compare-tray], [data-compare-page]');
      const index = selection.findIndex(item => item.handle === remove.dataset.compareRemove);
      selection = selection.filter(item => item.handle !== remove.dataset.compareRemove);
      persist();
      if (page && selection.length === 0) {
        returnFromComparison();
        return;
      }
      sync(); if (page) render();
      const next = selection[Math.min(index, selection.length - 1)]?.handle;
      const target = Array.from(surface?.querySelectorAll('[data-compare-remove]') || []).find(button => button.dataset.compareRemove === next);
      (target || surface?.querySelector('[data-compare-toggle]') || page?.querySelector('[data-compare-back]') || document.querySelector('[data-compare-toggle]'))?.focus({preventScroll: true});
    }
  });
  window.addEventListener('storage', event => {
    if (event.key === KEY || event.key === null) { selection = read(); sync(); if (page) render(); }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) { selection = read(); sync(); if (page) render(); }
  });
  const content = document.querySelector('#main, main, [role="main"]');
  if (content && !page) {
    let frame;
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-compare-block], [data-compare-toggle]') || node.querySelector('[data-compare-toggle]'))))) {
        if (!frame) frame = requestAnimationFrame(() => { frame = null; sync(); });
      }
    }).observe(content, {childList: true, subtree: true});
  }

  function productData(item) {
    if (cache.has(item.handle)) return cache.get(item.handle);
    const pending = (async () => {
      const productPath = new URL(item.url, location.origin).pathname.match(/\/products\/[^/]+$/)?.[0];
      if (!productPath) throw new Error('Product path missing');
      const url = previewUrl(localizedPath(productPath));
      url.searchParams.set('view', 'compare-data');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, {credentials: 'same-origin', signal: controller.signal});
        if (!response.ok) throw new Error('Product response failed');
        const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = fragment.querySelector('[data-compare-product]');
        if (!source || (item.id ? source.dataset.productId !== item.id : source.dataset.handle !== item.handle) || !source.querySelector('[data-compare-heading]')) throw new Error('Product data missing');
        return source;
      } finally { clearTimeout(timer); }
    })();
    cache.set(item.handle, pending);
    pending.catch(() => { if (cache.get(item.handle) === pending) cache.delete(item.handle); });
    return pending;
  }

  function buttonFor(item, action, label) {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset[action] = item.handle;
    button.textContent = action === 'compareRemove' ? '×' : label;
    button.className = action === 'compareRemove' ? 'comparison-page__remove' : 'comparison-page__retry';
    button.setAttribute('aria-label', `${label}: ${item.title || item.handle}`);
    return button;
  }

  function updateCard(entry) {
    const {item, cell, source, status} = entry;
    const active = cell.contains(document.activeElement) ? document.activeElement : null;
    const card = document.createElement('div');
    card.className = 'comparison-page__card';
    const remove = buttonFor(source ? {...item, title: source.querySelector('.comparison-data__title')?.textContent || item.title} : item, 'compareRemove', page.dataset.remove);
    card.append(remove);
    cell.replaceChildren(card);
    if (source) {
      const heading = source.querySelector('[data-compare-heading]').cloneNode(true);
      const actions = heading.querySelector('.comparison-data__actions');
      actions?.remove();
      heading.querySelectorAll('a[href]').forEach(link => { link.href = previewUrl(link.href).href; });
      actions?.querySelectorAll('a[href]').forEach(link => { link.href = previewUrl(link.href).href; });
      card.append(heading);
      if (actions) cell.append(actions);
    } else {
      const title = document.createElement('span');
      title.className = 'comparison-data__title';
      title.textContent = item.title || item.handle;
      const message = document.createElement('p');
      message.className = 'comparison-page__product-status';
      message.textContent = status === 'error' ? page.dataset.productError : page.dataset.loading;
      card.append(title, message);
      if (status === 'error') card.append(buttonFor(item, 'compareRetry', page.dataset.retry));
    }
    if (active) remove.focus({preventScroll: true});
  }

  function bottleValue(source) {
    const raw = source.querySelector('[data-compare-value="bottles"]')?.textContent.trim() || '';
    const explicit = raw.match(/^(\d+)\s*(?:Flaschen|bottles?|botellas?|garrafas?)?$/i);
    const title = source.querySelector('.comparison-data__title')?.textContent || '';
    const fallback = title.match(/\b(\d+)\s*(?:Flaschen|bottles?|botellas?|garrafas?)\b/i);
    const number = explicit?.[1] || fallback?.[1];
    return number ? `${number} ${page.dataset.bottleUnit}` : '';
  }

  function renderRows() {
    if (!page) return;
    const sources = selection.map(item => rendered.get(item.handle)?.source);
    const rows = page.querySelector('[data-compare-rows]');
    const fragment = document.createDocumentFragment();
    const differentOnly = page.querySelector('[data-compare-differences]').checked;
    page.querySelectorAll('.comparison-page__labels [data-key]').forEach(label => {
      const values = sources.map(source => {
        if (!source) return '';
        if (label.dataset.key === 'bottles') return bottleValue(source);
        const value = source.querySelector(`[data-compare-value="${label.dataset.key}"]`)?.textContent.trim() || '';
        if (label.dataset.key === 'description' && value.includes('&#')) {
          const decoder = document.createElement('textarea');
          decoder.innerHTML = value;
          return decoder.value;
        }
        return value;
      });
      if (values.every(value => value === '')) return;
      if (differentOnly && sources.length > 1 && sources.every(Boolean) && values.every(value => value === values[0])) return;
      const row = document.createElement('div');
      row.className = 'comparison-page__row';
      row.setAttribute('role', 'row');
      if (label.dataset.key === 'description') row.classList.add('comparison-page__row--description');
      const heading = document.createElement('div');
      heading.className = 'comparison-page__label';
      heading.setAttribute('role', 'rowheader');
      const headingText = document.createElement('span');
      headingText.textContent = label.textContent;
      heading.append(headingText);
      row.append(heading);
      values.forEach(value => {
        const cell = document.createElement('div');
        cell.className = 'comparison-page__cell';
        cell.setAttribute('role', 'cell');
        cell.textContent = value || page.dataset.dash;
        row.append(cell);
      });
      fragment.append(row);
    });
    rows.replaceChildren(fragment);
  }

  function renderStatus() {
    const entries = selection.map(item => rendered.get(item.handle));
    const loading = entries.some(entry => entry?.status === 'loading');
    const failed = entries.some(entry => entry?.status === 'error');
    page.querySelector('[data-compare-message]').textContent = !selection.length ? page.dataset.empty : loading ? page.dataset.loading : failed ? page.dataset.partialError : '';
    page.querySelector('[data-compare-grid]').setAttribute('aria-busy', String(loading));
  }

  function render() {
    if (!page) return;
    const version = ++renderVersion;
    const products = page.querySelector('[data-compare-products]');
    const scroll = page.querySelector('[data-compare-scroll]');
    const selected = new Set(selection.map(item => item.handle));
    rendered.forEach((entry, handle) => {
      if (!selected.has(handle)) { entry.cell.remove(); rendered.delete(handle); }
    });
    if (!products.firstElementChild) {
      const corner = document.createElement('div');
      corner.className = 'comparison-page__label';
      corner.setAttribute('role', 'columnheader');
      const label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = page.dataset.specs;
      corner.append(label);
      products.append(corner);
    }
    scroll.hidden = selection.length === 0;
    page.querySelector('[data-compare-grid]').style.setProperty('--compare-columns', Math.max(1, selection.length));
    page.querySelector('[data-compare-group-label]').setAttribute('aria-colspan', String(selection.length + 1));
    selection.forEach((item, index) => {
      let entry = rendered.get(item.handle);
      if (!entry) {
        const cell = document.createElement('div');
        cell.className = 'comparison-page__cell comparison-page__cell--heading';
        cell.setAttribute('role', 'columnheader');
        entry = {item, cell, source: null, status: 'idle'};
        rendered.set(item.handle, entry);
        products.append(cell);
      }
      if (products.children[index + 1] !== entry.cell) products.insertBefore(entry.cell, products.children[index + 1] || null);
      if (entry.status === 'ready' || entry.status === 'error') return;
      if (entry.status !== 'loading') {
        entry.status = 'loading';
        updateCard(entry);
      }
      productData(item).then(source => {
        if (version !== renderVersion) return;
        entry.source = source;
        entry.status = 'ready';
        updateCard(entry);
        renderRows(); renderStatus();
      }).catch(() => {
        if (version !== renderVersion) return;
        entry.status = 'error';
        updateCard(entry);
        renderRows(); renderStatus();
      });
    });
    renderRows(); renderStatus();
  }

  page?.querySelector('[data-compare-differences]')?.addEventListener('change', renderRows);
  sync();
  render();
})();
